import React from 'react'
import { Control, useController } from 'react-hook-form'

import { FormValues } from '@frame/components/screens/tasks/screens/stated-information/types'

import { Address } from './index'

type Props = {
  control: Control<FormValues>
  noAddress: boolean
  clearErrors: (key: string) => void
  disabled?: boolean
  required?: boolean
}

export function EmployerAddress({ noAddress, clearErrors, disabled = false, control, required }: Props) {
  const { field, fieldState } = useController({
    name: 'employer_address',
    control,
    rules: {
      validate: (value) => {
        if (!noAddress && !value?.place_id) {
          return 'Required'
        }
        return true
      },
    },
  })

  return (
    <Address
      name={field.name}
      value={field.value}
      label="Search Employer Address"
      noAddress={noAddress}
      onChange={field.onChange}
      errors={fieldState.error?.message}
      clearErrors={clearErrors}
      disabled={disabled}
      required={required}
    />
  )
}
